import React from 'react';
import CheckBoxInput from '../../../../controls/checkBoxInput.jsx';
import SelectInput from '../../../../controls/selectInput.jsx';
import TextInput from '../../../../controls/textInput.jsx';
import { apiGet, apiPost } from '../../../../services/apiClient';
import { getCurrentUserId, getRoles } from '../../../../services/userRights';
import { isUndefined } from 'util';

export default class PayerTab extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            busyCount: 0,
            initiators: [],
            subCompanies: [],
            shipmentTypes: [],
            shipmentPurposes: [],
            products: [],
            regions: [],
            costCenters: [],
            glAccounts: [],
			editVm: {
				canEditInitiator: false,
				canEditCrossSector: false,
				canEditShipmentType: false,
				canEditShipmentPurpose: false,
				canEditProduct: false,
				canEditRegion: false,
				canEditCostCenter: false,
				canEditGlAccount: false
			}
        };
		
        this.lastCrossSector = undefined;
        this.lastSubCompanyId = undefined;
        this.lastShipmentTypeId = undefined;
        this.lastShipmentPurposeId = undefined;
        this.lastProductId = undefined;
        this.lastInitiatorId = undefined;
        this.lastCostCenterId = undefined;
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    initParcelData(parcel) {
        parcel.initiatorId = null;
        parcel.isCrossSector = false;
        parcel.subCompanyId = null;
        parcel.initiatorIsCrossSector = false;
        parcel.initiatorSubCompanyId = null;
        parcel.shipmentTypeId = null;
        parcel.shipmentPurposeId = null;
        parcel.productId = null;
        parcel.activityCode = "";
        parcel.regionId = null;
        parcel.regionCode = "";
        parcel.costCenterId = null;
        parcel.glAccountId = null;
        return parcel;
    }

    reloadReferences() {
        this.updateBusyCount(1);
        let loadSubCompanies = apiGet('ref/subCompanies/list')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.subCompanies = data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        let currentUserId = getCurrentUserId();
        this.updateBusyCount(1);
        let loadInitiators = apiGet('ref/users/initiators')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.initiators = data.entries.map((entry, ind, array) => {
                        if (this.props.isNew && (entry.id === currentUserId || entry.isDefault)) {
                            let fieldsChanges = [
                                {
                                    name: "initiatorId",
                                    value: entry.id
                                },
                                {
                                    name: "isCrossSector",
                                    value: entry.isCrossSector
                                },
                                {
                                    name: "subCompanyId",
                                    value: entry.subCompanyId
                                },
                                {
                                    name: "initiatorIsCrossSector",
                                    value: entry.isCrossSector
                                },
                                {
                                    name: "initiatorSubCompanyId",
                                    value: entry.subCompanyId
                                }
                            ];
                            this.props.onFieldChange(fieldsChanges)
								.then(() => {
									if (this.props.isNew) {
										this.reloadReferencesWithDependences();
									}
								});
                        }
                        return {
                            value: entry.id,
                            label: entry.fullName,
                            subCompanyId: entry.subCompanyId,
                            isCrossSector: entry.isCrossSector
                        };
                    });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
        
        let loadOtherRefs = this.reloadReferencesWithDependences();

        return Promise.all([loadSubCompanies, loadInitiators, loadOtherRefs]);
    }

    reloadReferencesWithDependences() {
		let parcel = this.props.parcel;
        let loadShipmentTypes = Promise.resolve();
        let loadShipmentPurposes = Promise.resolve();
        let loadProducts = Promise.resolve();
        let loadRegions = Promise.resolve();
        let loadCostCenters = Promise.resolve();
        let loadGlAccounts = Promise.resolve();
        let loadControlStates = Promise.resolve();
		
        if (this.lastSubCompanyId !== parcel.subCompanyId
            || this.lastShipmentTypeId !== parcel.shipmentTypeId
            || this.lastShipmentPurposeId !== parcel.shipmentPurposeId
            || this.lastCrossSector !== parcel.isCrossSector) {
            this.updateBusyCount(1);
            let stateRequest = {
				isCrossSector: parcel.isCrossSector,
                subCompanyId: parcel.subCompanyId,
                shipmentTypeId: parcel.shipmentTypeId,
                shipmentPurposeId: parcel.shipmentPurposeId
            };
            loadControlStates = apiPost('parcels/payerTabState', stateRequest)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState({editVm: data});
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });
		}
		
        if (this.lastSubCompanyId !== parcel.subCompanyId
            || this.lastInitiatorId !== parcel.initiatorId
            || this.lastCrossSector !== parcel.isCrossSector) {
            this.updateBusyCount(1);
            let shipmentTypesRequest = {
				isCrossSector: parcel.isCrossSector,
                subCompanyId: parcel.subCompanyId,
                userId: parcel.initiatorId
            };
            loadShipmentTypes = apiPost('ref/shipmentTypes/list', shipmentTypesRequest)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        let hasSelection = false;
						let defaultValue = null;
                        prevState.shipmentTypes = data.entries.map((entry, ind, array) => {
                            if (entry.id === parcel.shipmentTypeId) {
                                hasSelection = true;
                            }
							let newEntry = { value: entry.id, label: entry.name };
							if (entry.isDefault) {
								defaultValue = newEntry;
							}
                            return newEntry;
                        });
						if ((parcel.shipmentTypeId === null || parcel.shipmentTypeId === undefined || !hasSelection) && defaultValue) {
                            this.handleSelectionChange('shipmentTypeId', defaultValue);
						} else if (!isUndefined(parcel.shipmentTypeId)) {
                            if (prevState.shipmentTypes.length === 1) {
                                this.handleSelectionChange('shipmentTypeId', prevState.shipmentTypes[0]);
                            } else if (!hasSelection) {
                                this.handleSelectionChange('shipmentTypeId', null);
                            }
                        }
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });
		}
		
        if (this.lastSubCompanyId !== parcel.subCompanyId
            || this.lastShipmentTypeId !== parcel.shipmentTypeId) {
            this.updateBusyCount(1);
            let shipmentPurposesRequest = {
                subCompanyId: parcel.subCompanyId,
                shipmentTypeId: parcel.shipmentTypeId
            };
            loadShipmentPurposes = apiPost('ref/shipmentPurposes/list', shipmentPurposesRequest)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        let hasSelection = false;
                        prevState.shipmentPurposes = data.entries.map((entry, ind, array) => {
                            if (entry.id === parcel.shipmentPurposeId) {
                                hasSelection = true;
                            }
                            return { value: entry.id, label: entry.name };
                        });
                        if (!isUndefined(parcel.shipmentPurposeId)) {
                            if (prevState.shipmentPurposes.length === 1) {
                                this.handleSelectionChange('shipmentPurposeId', prevState.shipmentPurposes[0]);
                            } else if (!hasSelection) {
                                this.handleSelectionChange('shipmentPurposeId', null);
                            }
                        }
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });
        }

        if (this.lastSubCompanyId !== parcel.subCompanyId
            || this.lastShipmentTypeId !== parcel.shipmentTypeId
            || this.lastCostCenterId !== parcel.costCenterId) {
            this.updateBusyCount(1);
            let regionsRequest = {
                subCompanyId: parcel.subCompanyId,
                shipmentTypeId: parcel.shipmentTypeId,
                costCenterId: parcel.costCenterId
            };
            loadRegions = apiPost('ref/regions/list', regionsRequest)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        let hasSelection = false;
                        prevState.regions = data.entries.map((entry, ind, array) => {
                            if (entry.id === parcel.regionId) {
                                hasSelection = true;
                            }
                            return { value: entry.id, label: entry.name, code: entry.code };
                        });
                        if (!isUndefined(parcel.regionId)) {
                            if (prevState.regions.length === 1) {
                                this.handleSelectionChange('regionId', prevState.regions[0]);
                            } else if (!hasSelection) {
                                this.handleSelectionChange('regionId', null);
                            }
                        }
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });
        }

        if (this.lastSubCompanyId !== parcel.subCompanyId
            || this.lastShipmentTypeId !== parcel.shipmentTypeId
            || this.lastShipmentPurposeId !== parcel.shipmentPurposeId
            || this.lastProductId !== parcel.productId
            || this.lastInitiatorId !== parcel.initiatorId
            || this.lastCrossSector !== parcel.isCrossSector) {
            this.updateBusyCount(1);
            let costCentersRequest = {
				isCrossSector: parcel.isCrossSector,
                subCompanyId: parcel.subCompanyId,
                shipmentTypeId: parcel.shipmentTypeId,
                shipmentPurposeId: parcel.shipmentPurposeId,
                productId: parcel.productId,
                userId: parcel.initiatorId
            };
            loadCostCenters = apiPost('ref/costCenters/list', costCentersRequest)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        let hasSelection = false;
						let defaultValue = null;
                        prevState.costCenters = data.entries.map((entry, ind, array) => {
                            if (entry.id === parcel.costCenterId) {
                                hasSelection = true;
                            }
							let newValue = { value: entry.id, label: entry.name };
							if (entry.isDefault) {
								defaultValue = newValue;
							}
                            return newValue;
                        });
						if ((parcel.costCenterId === undefined || parcel.costCenterId === null || !hasSelection) && defaultValue) {
                            this.handleSelectionChange('costCenterId', defaultValue);
						} else if (!isUndefined(parcel.costCenterId)) {
                            if (prevState.costCenters.length === 1) {
                                this.handleSelectionChange('costCenterId', prevState.costCenters[0]);
                            } else if (!hasSelection) {
                                this.handleSelectionChange('costCenterId', null);
                            }
                        }
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });
        }

        if (this.lastSubCompanyId !== parcel.subCompanyId
            || this.lastShipmentTypeId !== parcel.shipmentTypeId
            || this.lastShipmentPurposeId !== parcel.shipmentPurposeId) {
            this.updateBusyCount(1);
            let glAccountsRequest = {
                subCompanyId: parcel.subCompanyId,
                shipmentTypeId: parcel.shipmentTypeId,
                shipmentPurposeId: parcel.shipmentPurposeId
            };
            loadGlAccounts = apiPost('ref/glAccounts/list', glAccountsRequest)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        let hasSelection = false;
                        prevState.glAccounts = data.entries.map((entry, ind, array) => {
                            if (entry.id === parcel.glAccountId) {
                                hasSelection = true;
                            }
                            return { value: entry.id, label: entry.name, activityCode: entry.activityCode };
                        });
                        if (!isUndefined(parcel.glAccountId)) {
                            if (prevState.glAccounts.length === 1) {
                                this.handleSelectionChange('glAccountId', prevState.glAccounts[0]);
                            } else if (!hasSelection) {
                                this.handleSelectionChange('glAccountId', null);
                            }
                        }
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });

            this.updateBusyCount(1);
            let productsRequest = {
                subCompanyId: parcel.subCompanyId,
                shipmentTypeId: parcel.shipmentTypeId,
                shipmentPurposeId: parcel.shipmentPurposeId
            };
            loadProducts = apiPost('ref/products/list/', productsRequest)
                .then(data => {
                    this.updateBusyCount(-1);
                    this.setState((prevState, props) => {
                        let hasSelection = false;
						let defaultValue = null;
                        prevState.products = data.entries.map((entry, ind, array) => {
                            if (entry.id === parcel.productId) {
                                hasSelection = true;
                            }
							let newValue = { value: entry.id, label: entry.name, activityCode: entry.activityCode };
							if (entry.isDefault) {
								defaultValue = newValue;
							}
                            return newValue;
                        });
                        if (defaultValue && parcel.productId !== defaultValue.value) {
                            this.handleSelectionChange('productId', defaultValue);
						} else if (!isUndefined(parcel.productId)) {
                            if (prevState.products.length === 1) {
                                this.handleSelectionChange('productId', prevState.products[0]);
                            } else if (!hasSelection) {
                                this.handleSelectionChange('productId', null);
                            }
                        }
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                });
        }
		
        this.lastCrossSector = parcel.isCrossSector;
        this.lastSubCompanyId = parcel.subCompanyId;
        this.lastShipmentTypeId = parcel.shipmentTypeId;
        this.lastShipmentPurposeId = parcel.shipmentPurposeId;
        this.lastProductId = parcel.productId;
        this.lastInitiatorId = parcel.initiatorId;
        this.lastCostCenterId = parcel.costCenterId;

        return Promise.all([loadShipmentPurposes, loadShipmentTypes, loadProducts, loadRegions, loadCostCenters, loadGlAccounts, loadControlStates]);
    }

    fillModel(parcel) {
        parcel.initiatorId = this.props.parcel.initiatorId;
        parcel.isCrossSector = this.props.parcel.isCrossSector;
        parcel.subCompanyId = this.props.parcel.subCompanyId;
        parcel.shipmentTypeId = this.props.parcel.shipmentTypeId;
        parcel.shipmentPurposeId = this.props.parcel.shipmentPurposeId;
        parcel.productId = this.props.parcel.productId;
        parcel.regionId = this.props.parcel.regionId;
        parcel.costCenterId = this.props.parcel.costCenterId;
        parcel.glAccountId = this.props.parcel.glAccountId;
        return parcel;
    }

	isNextStepAvailable() {
		let canMove = true;
		if (this.state.editVm.canEditShipmentType) {
			canMove = canMove && this.props.parcel.shipmentTypeId !== undefined && this.props.parcel.shipmentTypeId !== null;
		}
		if (this.state.editVm.canEditShipmentPurpose) {
			canMove = canMove && this.props.parcel.shipmentPurposeId !== undefined && this.props.parcel.shipmentPurposeId !== null;
		}
		if (this.state.editVm.canEditProduct) {
			canMove = canMove && this.props.parcel.productId !== undefined && this.props.parcel.productId !== null;
		}
		if (this.state.editVm.canEditRegion) {
			canMove = canMove && this.props.parcel.regionId !== undefined && this.props.parcel.regionId !== null;
		}
		canMove = canMove && this.props.parcel.costCenterId !== undefined && this.props.parcel.costCenterId !== null;
		canMove = canMove && this.props.parcel.glAccountId !== undefined && this.props.parcel.glAccountId !== null;
		return canMove;
	}

    hasFormErrors(errors) {
        return !isUndefined(errors)
            && (errors.initiatorId
            || errors.subCompanyId
            || errors.shipmentTypeId
            || errors.shipmentPurposeId
            || errors.productId
            || errors.regionId
            || errors.costCenterId
            || errors.glAccountId);
    }

    validateForm(fieldName) {
        var result = null;

        if (isUndefined(fieldName) || fieldName === "initiatorId") {
            if (!this.props.parcel.initiatorId) {
                result = result ? result : {};
                result.initiatorId = "Инициатор является обязательным полем";
            }
        }

        if (isUndefined(fieldName) || fieldName === "subCompanyId") {
            if (!this.props.parcel.subCompanyId) {
                result = result ? result : {};
                result.subCompanyId = "Сектор является обязательным полем";
            }
        }

        if (isUndefined(fieldName) || fieldName === "shipmentTypeId") {
            if (!this.props.parcel.shipmentTypeId && this.state.editVm.canEditShipmentType) {
                result = result ? result : {};
                result.shipmentTypeId = "Тип отправки является обязательным полем";
            }
        }

        if (isUndefined(fieldName) || fieldName === "shipmentPurposeId") {
            if (!this.props.parcel.shipmentPurposeId && this.state.editVm.canEditShipmentPurpose) {
                result = result ? result : {};
                result.shipmentPurposeId = "Тип/цель отправки является обязательным полем";
            }
        }

        if (isUndefined(fieldName) || fieldName === "productId") {
            if (!this.props.parcel.productId && this.state.editVm.canEditProduct) {
                result = result ? result : {};
                result.productId = "Клиент/продукт является обязательным полем";
            }
        }

        if (isUndefined(fieldName) || fieldName === "regionId") {
            if (!this.props.parcel.regionId && this.state.editVm.canEditRegion) {
                result = result ? result : {};
                result.regionId = "Регион является обязательным полем";
            }
        }

        if (isUndefined(fieldName) || fieldName === "costCenterId") {
            if (!this.props.parcel.costCenterId) {
                result = result ? result : {};
                result.costCenterId = "Кост центр является обязательным полем";
            }
        }

        if (isUndefined(fieldName) || fieldName === "glAccountId") {
            if (!this.props.parcel.glAccountId) {
                result = result ? result : {};
                result.glAccountId = "GL аккаунт является обязательным полем";
            }
        }

        return result;
    }

	getFieldsChanges(name, selection, isSelection) {
        let newValue = isSelection ? (selection ? selection.value : null) : selection;
        let fieldsChanges = [
            {
                name: name,
                value: newValue
            }
        ];
        
        if (name === 'initiatorId') {
            fieldsChanges.push({
                name: 'isCrossSector',
                value: selection ? selection.isCrossSector : false
            });
            if (selection) {
                fieldsChanges.push({
                    name: 'subCompanyId',
                    value: selection.subCompanyId
                });
            }
            fieldsChanges.push({
                name: 'initiatorIsCrossSector',
                value: selection ? selection.isCrossSector : false
            });
            fieldsChanges.push({
                name: 'initiatorSubCompanyId',
                value: selection ? selection.subCompanyId : null
            });
        } else if (name === 'regionId') {
            fieldsChanges.push({
                name: 'regionCode',
                value: selection ? selection.code : ""
            });
        } else if (name === 'productId') {
            fieldsChanges.push({
                name: 'activityCode',
                value: selection ? selection.activityCode : ""
            });
        } else if (name === 'isCrossSector' && !newValue) {
            fieldsChanges.push({
                name: 'subCompanyId',
                value: this.props.parcel.initiatorSubCompanyId
            });
        }

		return fieldsChanges;
	}

    handleSelectionChange(name, selection) {
        let newValue = selection ? selection.value : null;
        let fieldsChanges = this.getFieldsChanges(name, selection, true);
        this.props.onFieldChange(fieldsChanges)
			.then(() => {
				this.handleFieldEdited(name, newValue);
				if (this.props.isNew) {
					this.reloadReferencesWithDependences();
				}
			});
    }

	handleInputEdited(name, value) {
        let fieldsChanges = this.getFieldsChanges(name, value, false);
        this.props.onFieldChange(fieldsChanges)
			.then(() => {
				this.handleFieldEdited(name, value);
				if (this.props.isNew && name === "isCrossSector") {
					this.reloadReferencesWithDependences();
				}
			});
	}

    handleFieldEdited(name, value) {
        if (this.props.onFieldEdited) {
            this.props.onFieldEdited(name, value);
        }
    }

    render() {
		let isCoordinator = getRoles().indexOf('Coordinator') >= 0;
        let isOnlyBeforeSendEditable = this.props.isNew 
									|| this.props.parcel.statusCode === "Created" 
									|| (this.props.parcel.statusCode === "SentToMailRoom" && isCoordinator);
        let isBusy = this.props.isBusy || this.state.busyCount > 0;
        return (
            <div>
				<div className="row">
                    <div className="col-sm-12">
                        <div>
                            <h4 className="text-center">Инициатор отправки</h4>
                        </div>
                    </div>
				</div>

                <div className="row">
                    <div className="col-sm-6">
                        <div className={"form-group" + (this.props.errors.initiatorId ? " has-error" : "")}>
                            <label htmlFor="selectInitiator">Инициатор<span className="text-red">*</span></label>
							<a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Инициатор" 
							   data-content="Инициатор - это тот, кто платит за отправку">
								<span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
							</a>
                            <SelectInput id="selectInitiator"
                                clearable={false}
                                options={this.state.initiators}
                                value={this.props.parcel.initiatorId}
								title={this.props.errors.initiatorId}
                                onChange={e => this.handleSelectionChange("initiatorId", e)}
                                disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditInitiator}
                            />
                            <div className="checkbox">
                                <label>
                                    <CheckBoxInput id="inputIsCrossSector" 
										checked={this.props.parcel.isCrossSector} 
										onChange={e => this.handleInputEdited("isCrossSector", e)}
										disabled={isBusy || !isOnlyBeforeSendEditable || this.props.parcel.initiatorIsCrossSector || !this.state.editVm.canEditCrossSector} />
                                    Кросс-функция
                                </label>
								<a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Кросс-функция" 
									data-content="Выберите, только если вы кросс-секторальный сотрудник и отправка для целей определенного сектора">
									<span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
								</a>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6">
                        <div className={"form-group" + (this.props.errors.subCompanyId ? " has-error" : "")}>
                            <label htmlFor="selectSubCompany">Сектор<span className="text-red">*</span></label>
                            <SelectInput id="selectSubCompany"
                                clearable={false}
                                options={this.state.subCompanies}
                                value={this.props.parcel.subCompanyId}
								title={this.props.errors.subCompanyId}
                                onChange={e => this.handleSelectionChange("subCompanyId", e)}
                                disabled={isBusy || !this.props.parcel.isCrossSector || !isOnlyBeforeSendEditable}
                            />
                        </div>
                    </div>
                </div>

				<div className="row">
                    <div className="col-sm-12">
                        <div>
                            <h4 className="text-center">Данные плательщика</h4>
                        </div>
                    </div>
				</div>

                <div className="row">
                    <div className="col-sm-6">
                        <div className={"form-group" + (this.props.errors.shipmentTypeId ? " has-error" : "")}>
                            <label htmlFor="selectShipmentType">
								Тип отправки
								<span className={"text-red" + (this.state.editVm.canEditShipmentType ? "" : " hidden")}>*</span>
							</label>
							<a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Тип отправки" 
							   data-content="Рекламные материалы - все что относится к продукту и продвижению продукта. В остальных случаях выбирается Не реклама">
								<span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
							</a>
                            <SelectInput id="selectShipmentType"
                                clearable={false}
                                options={this.state.shipmentTypes}
                                value={this.props.parcel.shipmentTypeId}
								title={this.props.errors.shipmentTypeId}
                                onChange={e => this.handleSelectionChange("shipmentTypeId", e)}
                                disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditShipmentType}
                            />
                        </div>

                        <div className={"form-group" + (this.props.errors.shipmentPurposeId ? " has-error" : "")}>
                            <label htmlFor="selectShipmentPurpose">
								Тип/цель отправки
								<span className={"text-red" + (this.state.editVm.canEditShipmentPurpose ? "" : " hidden")}>*</span>
							</label>
							<a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Тип/цель отправки" 
							   data-content="Вид промо">
								<span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
							</a>
                            <SelectInput id="selectShipmentPurpose"
                                options={this.state.shipmentPurposes}
                                value={this.props.parcel.shipmentPurposeId}
								title={this.props.errors.shipmentPurposeId}
                                onChange={e => this.handleSelectionChange("shipmentPurposeId", e)}
                                disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditShipmentPurpose}
                            />
                        </div>

                        <div className={"form-group" + (this.props.errors.regionId ? " has-error" : "")}>
                            <label htmlFor="selectRegionId">
								Регион
								<span className={"text-red" + (this.state.editVm.canEditRegion ? "" : " hidden")}>*</span>
							</label>
                            <SelectInput id="selectRegionId"
                                options={this.state.regions}
                                value={this.props.parcel.regionId}
								title={this.props.errors.regionId}
                                onChange={e => this.handleSelectionChange("regionId", e)}
                                disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditRegion}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="inputRegionCode">Код региона</label>
							<a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Код региона" 
							   data-content="Код региона - финансовый код региона">
								<span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
							</a>
                            <TextInput id="inputRegionCode" value={this.props.parcel.regionCode} disabled />
                        </div>
                    </div>

                    <div className="col-sm-6">
                        <div className={"form-group" + (this.props.errors.productId ? " has-error" : "")}>
                            <label htmlFor="selectProduct">
								Клиент/продукт
								<span className={"text-red" + (this.state.editVm.canEditProduct ? "" : " hidden")}>*</span>
							</label>
							<a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Клиент/продукт" 
							   data-content="Для секторов Pharma, MD, Consumer выбирается продукт. Для сектора Vistakon в данном поле выбирается клиент.">
								<span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
							</a>
                            <SelectInput id="selectProduct"
                                options={this.state.products}
                                value={this.props.parcel.productId}
								title={this.props.errors.productId}
                                onChange={e => this.handleSelectionChange("productId", e)}
                                disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditProduct}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="inputActivityCode">Активити код</label>
                            <TextInput id="inputActivityCode" value={this.props.parcel.activityCode} disabled />
                        </div>

                        <div className={"form-group" + (this.props.errors.costCenterId ? " has-error" : "")}>
                            <label htmlFor="selectCostCenter">Кост центр<span className="text-red">*</span></label>
                            <SelectInput id="selectCostCenter"
                                clearable={false}
                                options={this.state.costCenters}
                                value={this.props.parcel.costCenterId}
								title={this.props.errors.costCenterId}
                                onChange={e => this.handleSelectionChange("costCenterId", e)}
                                disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditCostCenter}
                            />
                        </div>

                        <div className={"form-group" + (this.props.errors.glAccountId ? " has-error" : "")}>
                            <label htmlFor="selectGlAccountId">GL аккаунт<span className="text-red">*</span></label>
                            <SelectInput id="selectGlAccountId"
                                clearable={false}
                                options={this.state.glAccounts}
                                value={this.props.parcel.glAccountId}
								title={this.props.errors.glAccountId}
                                onChange={e => this.handleSelectionChange("glAccountId", e)}
                                disabled={isBusy || !isOnlyBeforeSendEditable || !this.state.editVm.canEditGlAccount}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/parcels/form/tabs/payerTab.jsx